export const PLCC_CHECKOUT_LABELS = 'checkout';
export const GLOBAL_ADDEDTOBAG = 'global';
export const shippingAdressLabel = 'lbl_plcc_ic_shipping_adress';
export const buyNowLabel = 'lbl_plcc_ic_buy_now';
export const plccToolTipMessage1 = 'lbl_plcc_ic_toolTip_message_1';
export const plccToolTipMessage2 = 'lbl_plcc_ic_toolTip_message_2';
export const termsAndConditionApp = 'lbl_plcc_ic_termsCondition_preText_app';
export const applyConditionPolicyText = 'lbl_review_applyConditionPolicyText';
export const applyConditionAndText = 'lbl_review_applyConditionAndText';
export const couponsError = 'lbl_checkoutmodal_couponError';

const PlccCheckoutLabels = {
  checkout: {
    bagPage: {
      [shippingAdressLabel]: 'Shipping to #adress',
      [buyNowLabel]: 'BUY NOW',
      [plccToolTipMessage1]:
        'NEW! Buy Now is the fastest way to check out every time you shop with your online account.',
      [plccToolTipMessage2]:
        'When you select Buy Now, we’ll charge the My Place Rewards Credit Card saved in your account and deliver to your default shipping address. Your order will be placed with a single click, and you’ll be directed to the Order Confirmation page. ',
      [termsAndConditionApp]: 'By selecting “Buy Now”, I agree to the ',
    },
    review: {
      [applyConditionAndText]: ' and ',
      [applyConditionPolicyText]: 'Privacy Policy.',
    },
  },
  global: {
    checkoutConfirmation: {
      [couponsError]:
        'Some of the Coupons in your Basket has been expired, please remove to proceed further for checkout.', // may be dynamic label
    },
  },
};

export default PlccCheckoutLabels;
